import React from 'react';
import head from '../../assets/head3.PNG';
import './header.css';

const Header = () => (
    <div className="sam__header section__padding" id="home">
        <div className="sam__header-image">
            <img src={head} />
        </div>
        <div className="sam__header-content">
            <h1 className="gradient__text" dir='rtl'>به شرکت توسعه فناوران رایا خوش آمدید</h1>
            <p dir='rtl'>شرکت توسعه فناوران رایا همواره در تلاش است تا با به کارگیری تیم مجرب خود، بهترین راه کار هارا برای شما و کسب کار شما در حوزه ورود به صنعت دیجیتال و دیجیتال مارکتینگ ارائه دهد.</p>
        </div>


    </div>
);

export default Header;
